import api from 'service/api'

const dponetAPI = api.create('dponet')

const all = async ({ ...params }) => {
  return await dponetAPI.get(
    '/backoffice/organizations/organization_users/all',
    {
      params,
    },
  )
}

const create = async ({ id = '', ...params }) => {
  return await dponetAPI.post(
    `/backoffice/organizations/${id}/organization_users`,
    {
      ...params,
    },
  )
}

const update = async ({ organizationId = '', id = '', ...params }) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/organization_users/${id}`,
    {
      ...params,
    },
  )
}

const changeStatus = async ({
  organizationId = '',
  organizationUserId = '',
  ...params
}) => {
  return await dponetAPI.put(
    `/backoffice/organizations/${organizationId}/organization_users/${organizationUserId}/change_status`,
    params,
  )
}

const destroy = async ({ organizationId = '', id = '' }) => {
  return await dponetAPI.delete(
    `/backoffice/organizations/${organizationId}/organization_users/${id}`,
  )
}

const organizationUsers = { all, changeStatus, create, destroy, update }

export default organizationUsers
